export default "__VITE_ASSET__CkQB$BW1__"